const tabs = [
  {
    id: 1,
    nameId: 'all',
    label: 'All assessors',
    intlKey: 'tabs.assessors_all',
    path: '/all',
    maxLevel: 2
  },
  {
    id: 2,
    nameId: 'pending',
    label: 'Pending',
    intlKey: 'tabs.pending',
    path: '/pending',
    maxLevel: 2
  },
  {
    id: 3,
    nameId: 'cpn_expires',
    label: 'CPN expires <60 days',
    intlKey: 'tabs.cpn_expires',
    path: '/cpn-expires',
    maxLevel: 2
  },
  {
    id: 4,
    nameId: 'cpn_expired',
    label: 'CPN expired',
    intlKey: 'tabs.cpn_expired',
    path: '/cpn-expired',
    maxLevel: 2
  },
  {
    id: 5,
    nameId: 'archived',
    label: 'Archived',
    intlKey: 'tabs.archived',
    path: '/archived',
    maxLevel: 2
  }]

export default tabs
